// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4209":"95224f52","6186":"2a36b0e6","8247":"a4a4ceba","8784":"2a36b0e6","8927":"2ddcc344"}[chunkId] + ".chunk.css";
};